// extracted by css-extract-rspack-plugin
export default {"container":"container-z7yvqa"};